import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-413e21b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "navigator",
  class: "navbar navbar-expand-lg navbar-dark"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "navbar-brand" }, "書蠹付梓 | 無縫閱讀", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNav",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  id: "navbarNav",
  class: "navbar-collapse collapse row"
}
const _hoisted_6 = {
  id: "left-nav",
  class: "navbar-nav col-8"
}
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-link" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-link" }
const _hoisted_11 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_12 = { class: "nav-link" }
const _hoisted_13 = {
  id: "right-nav",
  class: "navbar-nav col-4"
}
const _hoisted_14 = { class: "nav-item dropdown" }
const _hoisted_15 = {
  id: "navbarDropdown",
  class: "nav-link dropdown-toggle",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_16 = {
  class: "dropdown-menu dropdown-menu-lg-end",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "dropdown-item" }, "註冊", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "dropdown-item" }, "登入", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: { name: 'home' } }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, { to: { name: 'home' } }, {
              default: _withCtx(() => [
                _createElementVNode("a", _hoisted_8, [
                  _createVNode(_component_font_awesome_icon, { icon: "home" }),
                  _createTextVNode(" 首頁 ")
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, { to: { name: 'list' } }, {
              default: _withCtx(() => [
                _createElementVNode("a", _hoisted_10, [
                  _createVNode(_component_font_awesome_icon, { icon: "book-open" }),
                  _createTextVNode(" 列表 ")
                ])
              ]),
              _: 1
            })
          ]),
          (_ctx.user.account === 'admin')
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _createVNode(_component_router_link, { to: { name: 'admin' } }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", _hoisted_12, [
                      _createVNode(_component_font_awesome_icon, { icon: "columns" }),
                      _createTextVNode(" 後台 ")
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("ul", _hoisted_13, [
          _createElementVNode("li", _hoisted_14, [
            _createElementVNode("a", _hoisted_15, [
              _createVNode(_component_font_awesome_icon, { icon: "user" })
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_ctx.isLogin === true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.user.account), 1),
                    _createVNode(_component_router_link, {
                      to: { name: 'userinfo' },
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("資訊")
                      ]),
                      _: 1
                    }),
                    _hoisted_19,
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout())),
                      class: "dropdown-item",
                      href: "#"
                    }, "登出")
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.user.account), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { name: 'register' } }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { name: 'login' } }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      })
                    ])
                  ]))
            ])
          ])
        ])
      ])
    ])
  ]))
}